import { MarqueeStrip } from './MarqueeStrip/MarqueeStrip.js';
import { ProgressiveDialog } from './ProgressiveDialog/ProgressiveDialog.js';

export default {
  /**
   * @param {import('../app.js').App} _app
   */
  install(_app) {
    MarqueeStrip.define();
    ProgressiveDialog.define();
  },
};